// extracted by mini-css-extract-plugin
export const sectionSpacing = "resource-module--section-spacing--3pQ4l";
export const rowSpacing = "resource-module--row-spacing--3pape";
export const rowSpacingSml = "resource-module--row-spacing-sml--11avf";
export const resource = "resource-module--resource--kRAm2";